import React from 'react';
import { shortAddress, copyToClipboard } from '../../utils/format';
import { notify } from '../../utils/notify';

const UserProfileCard = ({ userId, referrerId, wallet, active, isBlacklisted, rank }) => {
  const refLink = `${window.location.origin}/invest?ref=${userId || ''}`;

  const copy = async (text, label) => {
    const ok = await copyToClipboard(text);
    if (ok) notify.success(`${label} copied`);
    else notify.error('Failed to copy');
  };

  return (
    <div className="profile-card">
      <div className="profile-card-bg" />

      <div className="profile-card-top">
        <div className="profile-avatar">
          <div className="profile-avatar-inner">
            <span>{userId ? String(userId).slice(-2) : '··'}</span>
          </div>
          <div className="profile-avatar-ring" />
        </div>

        <div className="profile-meta">
          <div className="profile-tag-row">
            <div className="profile-tag">
              <span className="profile-tag-dot" />
              {isBlacklisted ? 'BLACKLISTED' : (active ? 'ACTIVE STAKER' : 'INACTIVE')}
            </div>
            {rank && rank.name && (
              <div className="profile-rank-badge" style={{
                color: rank.color,
                borderColor: `${rank.color}66`,
                background: `${rank.color}11`,
                textShadow: `0 0 10px ${rank.color}aa`
              }}>
                <span className="profile-rank-icon">★</span>
                {rank.name}
                {rank.level > 0 && (
                  <span className="profile-rank-level">L{rank.level}</span>
                )}
              </div>
            )}
          </div>
          <div className="profile-name">User #{userId || '—'}</div>
          <div className="profile-wallet">
            {shortAddress(wallet)}
            <button
              className="profile-icon-btn"
              onClick={() => copy(wallet, 'Address')}
              title="Copy address"
            >⎘</button>
          </div>
        </div>

        <div className="profile-id-grid">
          <div className="profile-id-box">
            <div className="profile-id-label">Your ID</div>
            <div className="profile-id-value">#{userId || '—'}</div>
            {userId ? (
              <button
                className="profile-icon-btn"
                onClick={() => copy(String(userId), 'User ID')}
                title="Copy ID"
              >⎘</button>
            ) : null}
          </div>
          <div className="profile-id-box upline">
            <div className="profile-id-label">Upline</div>
            <div className="profile-id-value">
              {referrerId && referrerId !== '0' ? `#${referrerId}` : '—'}
            </div>
            {referrerId && referrerId !== '0' ? (
              <button
                className="profile-icon-btn"
                onClick={() => copy(String(referrerId), 'Upline ID')}
                title="Copy upline ID"
              >⎘</button>
            ) : null}
          </div>
        </div>
      </div>

      <div className="profile-card-divider" />

      <div className="profile-ref-section">
        <div className="profile-ref-label">Your Referral Link</div>
        <div className="profile-ref-row">
          <div className="profile-ref-link">{refLink}</div>
          <button
            className="profile-ref-copy"
            onClick={() => copy(refLink, 'Referral link')}
          >Copy</button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileCard;
